<template>
  <div class="table table-bg treeview search">
    <div class="table-header center">
      <div class="table-tlt center-left">
        <h2>매출 리스트</h2>
      </div>
      <div v-if="device" class="strong-text row">
        <div class="strong-text-header">
         <span class="title wp8">판매개수</span>
         <span class="title wp14">판매금액</span>
         <span class="title wp14">판매이익</span>
         <span class="title wp8">폐기개수</span>
         <span class="title wp14">폐기금액</span>
         <span class="title wp14">기타손실</span>
         <!-- TODO <span class="title wp14">기타수익</span> -->
         <span class="title wp14">영업이익</span>
        </div>
        <div class="strong-text-body">
          <span class="wp8" :class="device.saleCount > 0 ? 'plus' : (device.saleCount < 0 ? 'minus': 'zero')">{{ Number(device.saleCount).toLocaleString() }}</span>
          <span class="wp14" :class="device.saleTotal > 0 ? 'plus' : (device.saleTotal < 0 ? 'minus': 'zero')">{{ Number(device.saleTotal).toLocaleString() }}</span>
          <span class="wp14" :class="device.saleProfit > 0 ? 'plus' : (device.saleProfit < 0 ? 'minus': 'zero')">{{ Number(device.saleProfit).toLocaleString() }}</span>
          <span class="wp8" :class="device.discardCount > 0 ? 'plus' : (device.discardCount < 0 ? 'minus': 'zero')">{{ Number(device.discardCount).toLocaleString() }}</span>
          <span class="wp14" :class="device.discardTotal > 0 ? 'plus' : (device.discardTotal < 0 ? 'minus': 'zero')">{{ Number(device.discardTotal).toLocaleString() }}</span>
          <span class="wp14" :class="device.etcLoss > 0 ? 'plus' : (device.etcLoss < 0 ? 'minus': 'zero')">{{ Number(device.etcLoss).toLocaleString() }}</span>
          <!-- TODO <span class="wp14" :class="device.etcProfit > 0 ? 'plus' : (device.etcProfit < 0 ? 'minus': 'zero')">{{ Number(device.etcProfit).toLocaleString() }}</span> -->
          <span class="wp14" :class="device.profit > 0 ? 'plus' : (device.profit < 0 ? 'minus': 'zero')">{{ Number(device.profit).toLocaleString() }}</span>
        </div>
      </div>
      <div class="table-btn center-right">
        <div class="btn-export-excel" @click="downloadExcel(false)">
          <button class="btn btn-40" :disabled="downloading">
            <span v-if="!downloading"><img src="/static/img/ico_excel@2x.png" alt=""></span>
            <ButtonLoading v-else></ButtonLoading>
          </button>
        </div>
        <!-- <div @click="downloadAllExcel"> -->
        <div @click="downloadExcel(true)">
          <button class="btn btn-140">
            <span v-if="!downloading" class="download-all">전체 엑셀 다운로드</span>
            <ButtonLoading v-else></ButtonLoading>
          </button>
        </div>
      </div>
    </div>
    <div class="table-desc">
      <table>
        <tr class="header">
          <th>트레이 이름</th>
          <th>상품 이름</th>
          <th>판매 개수</th>
          <th>판매 금액</th>
          <th>판매 이익</th>
          <th>폐기 개수</th>
          <th>폐기 금액</th>
          <th>기타 손실</th>
          <!-- TODO <th>기타 수익</th> -->
          <th>영업 이익</th>
          <!--
          <th>취소</th>
          <th>재결제</th>
          <th>환불</th>
          <th>미결제손실</th>
          <th>미결제후결제</th>
          <th>-정정</th>
          <th>+정정</th>
          <th>+정정(에러)</th>
          -->
        </tr>

        <tbody v-if="loading === false && total > 0">
          <tr v-for="item in list" :key="item.trayID">
            <td>
              <div>{{ item.trayName }}</div>
            </td>
            <td>
              <div>{{ item.productName }}</div>
            </td>
            <td>
              <div>{{ Number(item.saleCount).toLocaleString()  }}</div>
            </td>
            <td>
              <div style="color:blue;">{{ Number(item.saleTotal).toLocaleString()  }}</div>
            </td>
            <td>
              <div>{{ Number(item.saleProfit).toLocaleString()  }}</div>
            </td>
            <td>
              <div>{{ Number(item.discardCount).toLocaleString()  }}</div>
            </td>
            <td>
              <div>{{ Number(item.discardTotal).toLocaleString()  }}</div>
            </td>
            <td>
              <div>{{ Number(item.etcLoss).toLocaleString()  }}</div>
            </td>
            <!-- TODO
            <td>
              <div>{{ Number(item.etcProfit).toLocaleString()  }}</div>
            </td>
            -->
            <td>
              <div style="color:red;">{{ Number(item.profit).toLocaleString()  }}</div>
            </td>
            <!--
            <td>
              <div>{{ Number(item.cancelTotal).toLocaleString()  }}</div>
            </td>
            <td>
              <div>{{ Number(item.rebillTotal).toLocaleString()  }}</div>
            </td>
            <td>
              <div>{{ Number(item.refundTotal).toLocaleString()  }}</div>
            </td>
            <td>
              <div>{{ Number(item.nonpaymentTotal).toLocaleString()  }}</div>
            </td>
            <td>
              <div>{{ Number(item.nonpaymentBillTotal).toLocaleString()  }}</div>
            </td>
            <td>
              <div>{{ Number(item.correctRemoveTotal).toLocaleString()  }}</div>
            </td>
            <td>
              <div>{{ Number(item.correctAddTotal).toLocaleString()  }}</div>
            </td>
            <td>
              <div>{{ Number(item.correctAddSoldErrorTotal).toLocaleString()  }}</div>
            </td>
            -->
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="9">{{ loading ? '조회 중입니다.' : '조회 내역이 없습니다.' }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- <Loading v-if="loading || downloading"></Loading> -->
  </div>
</template>

<script>
/* eslint-disable no-alert */
/* eslint-disable no-console */
/* eslint-disable no-mixed-operators */
/* eslint-disable no-param-reassign */
/* eslint-disable no-plusplus */
/* eslint-disable no-await-in-loop */

import Configuration from '@/js/Configuration';
import js2excel from 'js2excel'; // https://github.com/dwqs/js2excel
import ButtonLoading from '@/components/include/ButtonLoading';
// import Loading from '@/components/include/Loading';

export default {
  props: [
    'deviceID',
    'selectEvent',
    'searchCondition', 'searchEvent',
  ],
  components: {
    ButtonLoading,
    // Loading,
  },
  data: () => ({
    list: [],
    total: 0,
    loading: true,
    downloading: false,
    device: null,
    productList: [],
    //
    scope: 0,
    role: 0,
    companyID: '',
  }),
  created() {
    //
    const token = this.$jwtDecode(this.$cookie.get('accessToken'));
    this.scope = token.scope;
    this.role = token.role;
    this.companyID = token.companyID;

    this.total = 0;
    this.getList(this.deviceID, false);
  },
  watch: {
    selectEvent() {
      this.total = 0;
      this.getList(this.deviceID, false);
    },
    searchEvent() {
      this.total = 0;
      this.getList(this.deviceID, false);
    },
  },
  methods: {
    async getList(deviceID, forDownload) {
      let device = null;
      const list = [];
      if (!forDownload) {
        this.loading = true;
        this.list = [];
      }

      try {
        let listURL = `${Configuration.value(
          'CPRODUCT_ADDRESS',
        )}/api/v1/cproduct/device/${deviceID}/tray/product/sales`;
        if (this.searchCondition) {
          listURL += `?${this.searchCondition}`;
        }
        const resList = await this.$http.get(listURL, {
          headers: {
            Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
          },
        });
        if (resList.status !== 200) {
          if (resList.status === 204) {
            if (!forDownload) {
              this.total = 0;
              this.loading = false;
            }
            return [device, list];
          }

          throw new Error(`response status is "${resList.status}"`);
        }
        if (resList.data.resultCode !== '0000') {
          throw new Error(`resultcode is "${resList.data.resultCode}"`);
        }

        device = resList.data.device;

        await this.getCompanyData(device, 1);
        await this.getCompanyData(device, 2);
        // await this.getDivisionData(device);
        // await this.getUserData(device);
        // await this.getProductList(device);

        device.manufactureDate = this.$moment(device.manufactureAt).format('YYYY.MM.DD');
        // device.manufactureTime = this.$moment(device.manufactureAt).format('hh:mm A');
        device.manufactureTime = this.$moment(device.manufactureAt).format('HH:mm:ss');
        device.setupDate = this.$moment(device.setupAt).format('YYYY.MM.DD');
        // device.setupTime = this.$moment(device.setupAt).format('hh:mm A');
        device.setupTime = this.$moment(device.setupAt).format('HH:mm:ss');

        let supplyTotal = 0;
        let profit = 0;
        let saleCount = 0;
        let saleTotal = 0;
        let saleProfit = 0;
        let etcLoss = 0;
        let etcProfit = 0;
        let discardCount = 0;
        let discardTotal = 0;
        let correctRemoveTotal = 0;
        let correctAddTotal = 0;
        let correctAddSoldErrorTotal = 0;
        if (resList.data.device.trays) {
          if (!forDownload) {
            this.total = resList.data.device.trays.length;
          }
          let num = this.total;

          for (let i = 0; i < resList.data.device.trays.length; i++) {
            const t = resList.data.device.trays[i];
            t.num = num;
            if (t.products && t.products.length > 0) {
              const p = t.products[0];
              t.productID = p.productID;
              t.productName = p.productName;
              t.discardCount = p.discardCount ? p.discardCount : 0;
              t.discardTotal = p.discardTotal ? p.discardTotal : 0;
              t.saleCount = p.saleCount ? p.saleCount : 0;
              t.saleTotal = p.saleTotal ? p.saleTotal : 0;
              t.supplyTotal = p.supplyTotal ? p.supplyTotal : 0;
              t.saleProfit = t.saleTotal - t.supplyTotal;
              //
              t.correctRemoveTotal = p.correctRemoveTotal ? p.correctRemoveTotal : 0;
              t.correctAddTotal = p.correctAddTotal ? p.correctAddTotal : 0;
              t.correctAddSoldErrorTotal = p.correctAddSoldErrorTotal ? p.correctAddSoldErrorTotal : 0;
              //
              t.cancelTotal = p.cancelTotal ? p.cancelTotal : 0;
              t.rebillTotal = p.rebillTotal ? p.rebillTotal : 0;
              t.refundTotal = p.refundTotal ? p.refundTotal : 0;
              t.nonpaymentTotal = p.nonpaymentTotal ? p.nonpaymentTotal : 0;
              t.nonpaymentBillTotal = p.nonpaymentBillTotal ? p.nonpaymentBillTotal : 0;
              t.nonpaymentBillTotalSupply = p.nonpaymentBillTotalSupply ? p.nonpaymentBillTotalSupply : 0;
              t.rebillTotalSupply = p.rebillTotalSupply ? p.rebillTotalSupply : 0;

              //
              t.nonpaymentProfit = t.nonpaymentBillTotal - t.nonpaymentBillTotalSupply;
              t.rebillProfit = t.rebillTotal - t.rebillTotalSupply;

              //
              // t.profit = t.saleTotal - t.supplyTotal - t.discardTotal - t.cancelTotal + t.rebillTotal - t.refundTotal - t.nonpaymentTotal + t.nonpaymentBillTotal;
              t.etcLoss = t.cancelTotal + t.refundTotal + t.nonpaymentTotal;
              // t.etcProfit = t.rebillTotal + t.nonpaymentBillTotal;
              t.etcProfit = t.rebillProfit + t.nonpaymentProfit;
              t.profit = t.saleTotal - t.supplyTotal - t.discardTotal - t.etcLoss + t.etcProfit;

              //
              supplyTotal += t.supplyTotal;
              saleCount += t.saleCount;
              saleTotal += t.saleTotal;
              saleProfit += t.saleProfit;
              discardCount += t.discardCount;
              discardTotal += t.discardTotal;
              correctRemoveTotal += t.correctRemoveTotal;
              correctAddTotal += t.correctAddTotal;
              correctAddSoldErrorTotal += t.correctAddSoldErrorTotal;

              //
              t.registrationNo = device.registrationNo;
              t.companyName = device.companyName;
              t.deviceRegistrationNo = device.deviceRegistrationNo;
              t.deviceCompanyName = device.deviceCompanyName;
              t.deviceID = device.deviceID;
              t.deviceName = device.deviceName;
            }
            t.count = 0;
            list.push(t);
            num--;
          }

          // profit = saleTotal - supplyTotal - discardTotal - device.cancelTotal + device.rebillTotal - device.refundTotal - device.nonpaymentTotal + device.nonpaymentBillTotal;
          etcLoss = device.cancelTotal + device.refundTotal + device.nonpaymentTotal;
          // etcProfit = device.rebillTotal + device.nonpaymentBillTotal;
          etcProfit = (device.rebillTotal - device.rebillTotalSupply) + (device.nonpaymentBillTotal - device.nonpaymentBillTotalSupply);
          profit = saleTotal - supplyTotal - discardTotal - etcLoss + etcProfit;

          device.saleCount = saleCount;
          device.saleTotal = saleTotal;
          device.saleProfit = saleProfit;
          device.etcLoss = etcLoss;
          device.etcProfit = etcProfit;
          device.profit = profit || 0;
          device.discardCount = discardCount;
          device.discardTotal = discardTotal;
          device.correctRemoveTotal = correctRemoveTotal;
          device.correctAddTotal = correctAddTotal;
          device.correctAddSoldErrorTotal = correctAddSoldErrorTotal;
        } else {
          device.saleCount = 0;
          device.saleTotal = 0;
          device.saleProfit = 0;
          device.etcLoss = 0;
          device.etcProfit = 0;
          device.profit = 0;
          device.discardCount = 0;
          device.discardTotal = 0;
          device.correctRemoveTotal = 0;
          device.correctAddTotal = 0;
          device.correctAddSoldErrorTotal = 0;
        }
        if (!forDownload) {
          this.list = list;
          this.device = device;
          this.loading = false;
        }
      } catch (e) {
        if (!forDownload) {
          this.total = 0;
          this.list = [];
          this.device = null;
          this.loading = false;
        }

        console.error(e);
      }
      return [device, list];
    },
    /*
    async getListForExcel(deviceID) {
      const saleList = [];
      try {
        let listURL = `${Configuration.value(
          'CPRODUCT_ADDRESS',
        )}/api/v1/cproduct/device/${deviceID}/tray/product/sales`;
        if (this.searchCondition) {
          listURL += `?${this.searchCondition}`;
        }
        const resList = await this.$http.get(listURL, {
          headers: {
            Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
          },
        });
        if (resList.status !== 200) {
          throw new Error(`response status is "${resList.status}"`);
        }
        if (resList.data.resultCode !== '0000') {
          throw new Error(`resultcode is "${resList.data.resultCode}"`);
        }

        const currentDevice = resList.data.device;

        await this.getCompanyData(currentDevice, 1);
        await this.getCompanyData(currentDevice, 2);

        if (!currentDevice.companyName) return [];

        currentDevice.manufactureDate = this.$moment(currentDevice.manufactureAt).format('YYYY.MM.DD');
        // currentDevice.manufactureTime = this.$moment(currentDevice.manufactureAt).format('hh:mm A');
        currentDevice.manufactureTime = this.$moment(currentDevice.manufactureAt).format('HH:mm:ss');
        currentDevice.setupDate = this.$moment(currentDevice.setupAt).format('YYYY.MM.DD');
        // currentDevice.setupTime = this.$moment(currentDevice.setupAt).format('hh:mm A');
        currentDevice.setupTime = this.$moment(currentDevice.setupAt).format('HH:mm:ss');

        let profit = 0;
        let saleCount = 0;
        let saleTotal = 0;
        let saleProfit = 0;
        let etcLoss = 0;
        let etcProfit = 0;
        let discardCount = 0;
        let discardTotal = 0;
        let correctRemoveTotal = 0;
        let correctAddTotal = 0;
        let correctAddSoldErrorTotal = 0;
        let cancelTotal = 0;
        let rebillTotal = 0;
        let refundTotal = 0;
        let nonpaymentTotal = 0;
        let nonpaymentBillTotal = 0;

        if (currentDevice.trays) {
          this.total = currentDevice.trays.length;

          for (let i = 0; i < currentDevice.trays.length; i++) {
            const t = currentDevice.trays[i];
            if (t.products && t.products.length > 0) {
              const it = t.products[0];

              it.etcLoss = it.cancelTotal + it.refundTotal + it.nonpaymentTotal;
              it.etcProfit = it.rebillTotal + it.nonpaymentBillTotal;
              it.profit = it.saleTotal - it.supplyTotal - it.discardTotal - it.etcLoss + it.etcProfit;

              saleList.push({
                사업자명: currentDevice.companyName,
                사업자번호: currentDevice.registrationNo,
                운영자명: currentDevice.deviceCompanyName,
                운영자사업자번호: currentDevice.deviceRegistrationNo,
                '냉장고 ID': currentDevice.deviceID,
                '냉장고 이름': currentDevice.deviceName,
                '트레이 ID': t.trayID,
                '트레이 이름': t.trayName,
                '상품 ID': it.productID,
                '상품 이름': it.productName,
                '판매 개수': it.saleCount,
                '판매 금액': it.saleTotal,
                '판매 이익': it.saleProfit || 0,
                '페기 개수': it.discardCount,
                '페기 금액': it.discardTotal,
                '기타 손실': it.etcLoss,
                '기타 수익': it.etcProfit,
                '영업 이익': it.profit,
                취소: it.cancelTotal,
                재결제: it.rebillTotal,
                환불: it.refundTotal,
                미결제손실: it.nonpaymentTotal,
                미결제후결제: it.nonpaymentBillTotal,
                '-정정': it.correctRemoveTotal,
                '+정정': it.correctAddTotal,
                '+정정(에러)': it.correctAddSoldErrorTotal,
              });

              saleCount += it.saleCount;
              saleTotal += it.saleTotal;
              saleProfit += it.saleProfit || 0;
              etcLoss += etcLoss;
              etcProfit += etcProfit;
              profit += profit;
              discardCount += it.discardCount;
              discardTotal += it.discardTotal;
              correctRemoveTotal += it.correctRemoveTotal;
              correctAddTotal += it.correctAddTotal;
              correctAddSoldErrorTotal += it.correctAddSoldErrorTotal;
              cancelTotal += it.cancelTotal;
              rebillTotal += it.rebillTotal;
              refundTotal += it.refundTotal;
              nonpaymentTotal += it.nonpaymentTotal;
              nonpaymentBillTotal += it.nonpaymentBillTotal;
            } else {
              saleList.push({
                사업자명: currentDevice.companyName,
                사업자번호: currentDevice.registrationNo,
                운영자명: currentDevice.deviceCompanyName,
                운영자사업자번호: currentDevice.deviceRegistrationNo,
                '냉장고 ID': currentDevice.deviceID,
                '냉장고 이름': currentDevice.deviceName,
                '트레이 ID': t.trayID,
                '트레이 이름': t.trayName,
                '상품 ID': '',
                '상품 이름': '',
                '판매 개수': 0,
                '판매 금액': 0,
                '판매 이익': 0,
                '페기 개수': 0,
                '페기 금액': 0,
                '기타 손실': 0,
                '기타 수익': 0,
                '영업 이익': 0,
                취소: 0,
                재결제: 0,
                환불: 0,
                미결제손실: 0,
                미결제후결제: 0,
                '-정정': 0,
                '+정정': 0,
                '+정정(에러)': 0,
              });
            }
          }

          saleList.push({
            사업자명: currentDevice.companyName,
            사업자번호: currentDevice.registrationNo,
            운영자명: currentDevice.deviceCompanyName,
            운영자사업자번호: currentDevice.deviceRegistrationNo,
            '냉장고 ID': currentDevice.deviceID,
            '냉장고 이름': currentDevice.deviceName,
            '트레이 ID': '전체',
            '트레이 이름': '전체',
            '상품 ID': '전체',
            '상품 이름': '전체',
            '판매 개수': saleCount,
            '판매 금액': saleTotal,
            '판매 이익': saleProfit,
            '페기 개수': discardCount,
            '페기 금액': discardTotal,
            '기타 손실': etcLoss,
            '기타 수익': etcProfit,
            '영업 이익': profit,
            취소: cancelTotal,
            재결제: rebillTotal,
            환불: refundTotal,
            미결제손실: nonpaymentTotal,
            미결제후결제: nonpaymentBillTotal,
            '-정정': correctRemoveTotal,
            '+정정': correctAddTotal,
            '+정정(에러)': correctAddSoldErrorTotal,
          });
        }
      } catch (e) {
        console.error(e);
        return [];
      }

      return saleList;
    },
    */
    async getCompanyData(value, n) {
      try {
        let companyID = null;

        if (n === 1) {
          companyID = value.companyID;
        } else {
          companyID = value.deviceCompanyID;
        }

        if (!companyID) {
          return;
        }

        const response = await this.$http.get(
          `${Configuration.value('CACCOUNT_ADDRESS')}/api/v1/caccount/company/${companyID}?withDivisions=false`,
          {
            headers: {
              Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
            },
          },
        );
        if (response.data.resultCode === '0000') {
          if (n === 1) {
            value.registrationNo = response.data.company.registrationNo;
            value.companyName = response.data.company.companyName;
          } else {
            value.deviceCompanyName = response.data.company.companyName;
            value.deviceRegistrationNo = response.data.company.registrationNo;
          }
        }
      } catch (e) {
        console.error(e);
      }
    },
    async getDivisionData(value) {
      try {
        const response = await this.$http.get(
          `${Configuration.value('CACCOUNT_ADDRESS')}/api/v1/caccount/division/${value.divisionID}?withUsers=false`,
          {
            headers: {
              Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
            },
          },
        );
        if (response.data.resultCode === '0000') {
          value.divisionName = response.data.division.divisionName;
        }
      } catch (e) {
        console.error(e);
      }
    },
    async getUserData(value) {
      try {
        const response = await this.$http.get(
          `${Configuration.value('CACCOUNT_ADDRESS')}/api/v1/caccount/user/${value.operatorUID}`,
          {
            headers: {
              Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
            },
          },
        );
        if (response.data.resultCode === '0000') {
          value.operatorName = response.data.user.name;
        }
      } catch (e) {
        console.error(e);
      }
    },
    async getProductList(value) {
      try {
        const response = await this.$http.get(
          `${Configuration.value('CPRODUCT_ADDRESS')}/api/v1/cproduct/product/list?page=1&limit=500&companyID=${value.companyID}`,
          {
            headers: {
              Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
            },
          },
        );
        if (response.data.resultCode === '0000') {
          this.productList = response.data.products;
        }
      } catch (e) {
        console.error(e);
      }
    },
    async downloadExcel(forAll) {
      try {
        if (this.downloading) return;

        this.downloading = true;

        let devices = [];
        if (forAll) {
          devices = await this.getDeviceList();
        } else {
          const d = {
            deviceID: this.deviceID,
          };
          devices.push(d);
        }

        const sales = [];
        for (let i = 0; i < devices.length; i++) {
          const deviceID = devices[i].deviceID;
          const [device, list] = await this.getList(deviceID, true);
          let index = 1;
          for (let j = 0; j < list.length; j++) {
            const it = list[j];
            const c = {
              번호: index,
              회사이름: it.companyName,
              사업자번호: it.registrationNo,
              운영회사명: it.deviceCompanyName,
              운영회사사업자번호: it.deviceRegistrationNo,
              '냉장고 ID': it.deviceID,
              '냉장고 이름': it.deviceName,
              '트레이 ID': it.trayID,
              '트레이 이름': it.trayName,
              '상품 ID': it.productID,
              '상품 이름': it.productName,
              '판매 개수': it.saleCount,
              '판매 금액': it.saleTotal,
              '판매 이익': it.saleProfit,
              '페기 개수': it.discardCount,
              '페기 금액': it.discardTotal,
              '기타 손실': it.etcLoss,
              '기타 수익': it.etcProfit,
              '영업 이익': it.profit,
              //
              취소: it.cancelTotal,
              재결제: it.rebillTotal,
              환불: it.refundTotal,
              미결제손실: it.nonpaymentTotal,
              미결제후결제: it.nonpaymentBillTotal,
              //
              //
              '-정정': it.correctRemoveTotal,
              '+정정': it.correctAddTotal,
              '+정정(에러)': it.correctAddSoldErrorTotal,
            };
            sales.push(c);
            index++;
          }

          //
          const c = {
            번호: '전체',
            사업자번호: device.registrationNo,
            회사이름: device.companyName,
            운영회사명: device.deviceCompanyName,
            운영회사사업자번호: device.deviceRegistrationNo,
            '냉장고 ID': device.deviceID,
            '냉장고 이름': device.deviceName,
            '트레이 ID': '전체',
            '트레이 이름': '전체',
            '상품 ID': '전체',
            '상품 이름': '전체',
            '판매 개수': device.saleCount,
            '판매 금액': device.saleTotal,
            '판매 이익': device.saleProfit,
            '페기 개수': device.discardCount,
            '페기 금액': device.discardTotal,
            '기타 손실': device.etcLoss,
            '기타 수익': device.etcProfit,
            '영업 이익': device.profit,
            //
            취소: device.cancelTotal,
            재결제: device.rebillTotal,
            환불: device.refundTotal,
            미결제손실: device.nonpaymentTotal,
            미결제후결제: device.nonpaymentBillTotal,
            //
            //
            '-정정': device.correctRemoveTotal,
            '+정정': device.correctAddTotal,
            '+정정(에러)': device.correctAddSoldErrorTotal,
          };
          sales.push(c);
        }

        if (sales.length === 0) {
          alert('다운로드할 내용이 없습니다.');
          this.downloading = false;
          return;
        }

        js2excel.json2excel({
          data: sales,
          name: 'cella-sale',
          formateDate: 'yyyy/mm/dd',
        });
      } catch (e) {
        console.error('downloadExcel error', e);
      }

      this.downloading = false;
      /*
      // for webpack 3: dynamic import
      // webpackChunkName: "js2excel"
      import('js2excel').then(({ json2excel }) => {
        json2excel({
          data: this.list,
          name: this.downloadFileName,
          formateDate: 'dd/mm/yyyy',
        });
      }).catch((e) => {

      });
      */
    },
    /*
    async downloadAllExcel() {
      let count = 0;

      try {
        const totalList = [];
        const devices = await this.getDeviceList();

        for (let i = 0; i < devices.length; i++) {
          const saleList = await this.getListForExcel(devices[i].deviceID);
          Array.prototype.push.apply(totalList, saleList);
        }

        if (totalList.length === 0) {
          alert('다운로드할 내용이 없습니다.');
          return count;
        }

        js2excel.json2excel({
          data: totalList,
          name: 'cella-sale-all',
          formateDate: 'yyyy/mm/dd',
        });
        count = totalList.length;
      } catch (e) {
        console.error(e);
        count = 0;
      }

      return count;
    },
    */
    async getDeviceList() {
      let deviceList = [];

      try {
        let getURL = `${Configuration.value(
          'CPRODUCT_ADDRESS',
        )}/api/v1/cproduct/device/list?page=1&limit=500`;

        //
        if (this.scope !== 1 && this.scope !== 2) {
          getURL += `&companyID=${this.companyID}`;
        }

        const result = await this.$http.get(getURL, {
          headers: {
            Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
          },
        });

        if (result.status === 200 && result.data.resultCode === '0000') {
          deviceList = result.data.devices;
        }
      } catch (e) {
        deviceList = [];
        console.error(e);
      }

      return deviceList;
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/sale/SaleList.vue